'use strict'

import angular from 'angular'

angular.module('buySheet.controllers', []).controller('BuySheetController', BuySheetController)

/**
 * @ngInject
 */
function BuySheetController($scope, $stateParams, $rootScope, $ioAlert, BuySheetService, CurrentUser, InstanceSettings) {
    $rootScope.loadertitle = ''
    $rootScope.loadingInProgress = true

    function setServerDataOn$scope(data) {
        $scope.orderId = $stateParams.orderId
        $scope.sectionToShow = 'buy-sheet-nav'
        $scope.buySheetConfigsIds = data.buy_sheet_templates_ids
        $rootScope.loadingInProgress = false
    }

    function handleError(error) {
        let e = 'Sorry, something went wrong here.'
        if  (error && error.data && error.data.message) {
            e += ` ${error.data.message}`;
        } else {
            e += ' Please refresh the page to try again.';
        }

        $scope.error = e
        $scope.sectionToShow = 'error'
        $rootScope.loadingInProgress = false;
    }

    CurrentUser.get().then((user) => {
        if (user.isAuthorizedToShowOrderBuySheet()) {
            InstanceSettings.getSettingType(InstanceSettings.EXPORT_BUYSHEET_TO_EXCEL).then((data) => {
                $scope.mayExportBuySheetToExcel = data && data.value == true
                BuySheetService.getBuySheetTemplates().then(setServerDataOn$scope, handleError)
            })

            return
        }

        $scope.sectionToShow = 'forbidden'
        $rootScope.loadingInProgress = false;
    })
}